export default class AnalysisMatch {

    time = null;
    league = null;
    homeId = null;
    homeName = 0;
    homeScore = 0;
    homeHalfScore = null;
    awayId = null;
    awayName = null;
    awayScore = null;
    awayHalfScore = null;
    asia = null;
    asiaString = 0;
    asiaResult = -100;
    daxiao = 0;
    daxiaoString = 0;
    daxiaoResult = -100;
    data = null;
    isHome = false;

    constructor(data) {
        if (data) {
            this.data = data;
            this.time = data[4];
            this.league = data[2];
            this.homeId = data[6][0];
            this.awayId = data[7][0];
            this.asia = this.getAsia();
            this.daxiao = this.getDaxiao();
        }
    }

    calcAsiaDx() {
        this.homeScore = this.getMatchScore(6);
        this.awayScore = this.getMatchScore(7);
        this.asiaResult = this.getAsiaResult();
        this.asiaString = this.getAsiaString();
        this.daxiaoResult = this.getDaxiaoResult();
        this.daxiaoString = this.getDaxiaoString();
    }

    getAsiaResult() {
        if (this.asiaResult == -100) {
            let asiz = this.homeScore - this.awayScore - this.asia;
            if (this.isHome) {
                this.asiaResult = asiz > 0 ? 1 : (asiz == 0 ? 0 : -1);
            } else {
                this.asiaResult = asiz > 0 ? -1 : (asiz == 0 ? 0 : 1);
            }
        }
        return this.asiaResult;
    }


    getAsiaString() {
        if (this.asia % 0.5 == 0) {
            this.asiaString = Math.round(this.asia * 100) / 100;
        } else {
            let num: number = this.asia - 0.25;
            let n2: any = num.toFixed(2);
            this.asiaString = Math.round(n2 / (this.asia + 0.25) * 100) / 100;
        }
        return this.asiaString;
    }

    getDaxiaoResult() {
        if (this.daxiaoResult == -100) {
            this.daxiaoResult = this.homeScore + this.awayScore - this.daxiao;
        }
        return this.daxiaoResult;
    }

    getDaxiaoString() {
        if (!this.daxiaoString) {
            if (this.daxiao % 0.5 == 0) {
                this.daxiaoString = Math.round(this.daxiao * 100) / 100;
            } else {
                this.daxiaoString = Math.round((this.daxiao - 0.25) / (this.daxiao + 0.25) * 100) / 100;
            }
        }
        return this.daxiaoString;
    }

    getAsia() {
        if (this.data) {
            let asia = this.data[8][0].split(',');
            if (asia && asia.length > 1) {
                let nasiz = Number(asia[1]);
                return isNaN(nasiz) ? 0 : nasiz;
            }
        }
        return 0;
    }

    getDaxiao() {
        if (this.data) {
            let dx = this.data[8][2].split(',');
            if (dx && dx.length > 1) {
                let nasiz = Number(dx[1]);
                return isNaN(nasiz) ? 0 : nasiz;
            }
        }
        return 0;
    }


    getMatchScore(idx) {
        if (this.data) {
            if (this.data[idx]) {
                return this.data[idx][2] + this.data[idx][3] + this.data[idx][4] + this.data[idx][5] + this.data[idx][6];
            }
        }
        return 0;
    }

}
